import { render, staticRenderFns } from "./AbsoluteTable.vue?vue&type=template&id=5641fa99&scoped=true&"
import script from "./AbsoluteTable.vue?vue&type=script&lang=js&"
export * from "./AbsoluteTable.vue?vue&type=script&lang=js&"
import style0 from "./AbsoluteTable.vue?vue&type=style&index=0&id=5641fa99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5641fa99",
  null
  
)

export default component.exports